/**
 * defaultTiendaPedidos.ts — Pedidos demo para la Tienda Virtual (modo local).
 * Las fechas se anclan al día calendario actual al sembrar.
 */
import type { Pedido } from "@/features/tienda/types/tienda.types";

export function buildDefaultTiendaPedidos(): Pedido[] {
  const now = new Date();
  const iso = (h: number, m = 0) => {
    const d = new Date(now);
    d.setHours(h, m, 0, 0);
    return d.toISOString();
  };

  return [
    {
      id: "ped_demo_1",
      businessId: "business_1",
      numero: 1042,
      items: [
        {
          productoId: "prod_demo_1",
          nombre: "Café Premium",
          precio: 7500,
          cantidad: 2,
          ventaPorPeso: false,
          subtotal: 15000,
        },
        {
          productoId: "prod_demo_2",
          nombre: "Croissant",
          precio: 5000,
          cantidad: 1,
          ventaPorPeso: false,
          subtotal: 5000,
        },
      ],
      total: 20000,
      cliente: {
        nombre: "Laura Gómez",
        telefono: "3005551234",
        direccion: "Calle 80 #12-45",
        metodoPago: "nequi",
        metodoPagoLabel: "Nequi",
      },
      estado: "pendiente",
      canal: "web",
      tipoEntrega: "domicilio",
      fechaCreacion: iso(9, 15),
      fechaActualizacion: iso(9, 15),
    },
    {
      id: "ped_demo_2",
      businessId: "business_1",
      numero: 1041,
      items: [
        {
          productoId: "prod_demo_3",
          nombre: "Jugo Natural",
          precio: 8000,
          cantidad: 3,
          ventaPorPeso: false,
          subtotal: 24000,
        },
      ],
      total: 24000,
      cliente: {
        nombre: "Andrés Mejía",
        telefono: "3108887766",
        direccion: "Carrera 15 #93-20",
        metodoPago: "efectivo",
        metodoPagoLabel: "Efectivo",
      },
      estado: "confirmado",
      canal: "web",
      tipoEntrega: "domicilio",
      fechaCreacion: iso(8, 40),
      fechaActualizacion: iso(10, 5),
    },
    {
      id: "ped_demo_3",
      businessId: "business_1",
      numero: 1040,
      items: [
        {
          productoId: "prod_demo_4",
          nombre: "Combo Desayuno",
          precio: 18500,
          cantidad: 1,
          ventaPorPeso: false,
          subtotal: 18500,
        },
      ],
      total: 18500,
      cliente: {
        nombre: "Cliente mostrador",
        telefono: "3000000000",
        metodoPago: "efectivo",
        metodoPagoLabel: "Efectivo",
      },
      estado: "entregado",
      canal: "web",
      tipoEntrega: "domicilio",
      fechaCreacion: iso(7, 20),
      fechaActualizacion: iso(8, 10),
    },
  ];
}
